import * as angular from "angular";
import {IController, IScope} from "angular";
import * as _ from "lodash";
import {CommonsAlertsService} from "../../../commons/services/commons-alerts.service";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {CommonsService} from "../../../commons/services/commons-service.service";
import {AuthenticationAlertsService} from "../../services/authentication-alerts.service";

export class resetViewCtrl implements IController {

  token: any;
  email?: string;

  public zxExtras: string[] = [];
  public passwordPolicy: any;

  private greetingTime: any;
  private imageGallery: any;
  private image: any;
  private password: any;
  private verifyPassword: any;
  private loading: any;

  /* @ngInject */
  constructor(private $log, private $scope: IScope, private $state, private IamRequests, private authenticationAlertsService: AuthenticationAlertsService, private commonsService: CommonsService,
              private commonsAlertsService: CommonsAlertsService, private commonsDialogService: CommonsDialogService, private commonsConstants) {
  }

  $onInit() {
    // Need to take it from global?
    this.passwordPolicy = {
      minScore: 2,
      minlength: 8,
      maxLoginAttemptsBeforeThrottle: 5,
      maxLoginAttemptsFromTheSameIP: 5,
      minutesToCheckSameIpLoginAttempt: 5,
      blockLoginByIpAfterMaximumAttempts: true
    };
    this.greetingTime = this.commonsService.getGreetingTime();
    this.imageGallery = this.commonsConstants.loginImageGalleriesByDayTime[this.greetingTime];

    this.image = this.imageGallery[Math.floor(Math.random() * this.imageGallery.length)];

    this.password = '';
    this.loading = false;

    this._zxExtras();
  };

  onPasswordChange(password) {
    this.password = password;
  }

  onVerifyPasswordChange(form) {
    form['verifyPassword'].$setValidity('mismatch', _.isEqual(this.password, this.verifyPassword));
  }

  resetClick(form) {
    if (form) {
      form.$setSubmitted(true);
      if (form.$valid) {
        this.loading = true;
        this.IamRequests.resetPassword(this.password, this.token)
          .then((success) => {
            if (success) {
              this.authenticationAlertsService.resetPasswordSuccess();
              this.$state.go('authentication.login');
            } else {
              this.authenticationAlertsService.resetPasswordError();
            }
          })
          .catch((error) => {
            this.authenticationAlertsService.resetPasswordError(error);
            this.$log.error('Reset password failed', error);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  }

  private _zxExtras() {
    this.zxExtras = this.email ?
      this.commonsService.buildZxExtras(this.email) :
      [];
  }

}

angular
  .module('bringoz.admin.authentication')
  .component('resetView', {
    bindings: {
      token: '<',
      email: '<?'
    },
    template: require('./reset-view.html').default,
    controller: resetViewCtrl
  });
